import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { NAV_LINKS, CONTACT } from '../mock';
import logo from '../assets/collins_logo.png';

const NavItem = ({ link, className, onClick }) => {
  if (link.href.startsWith('/')) {
    return (
      <Link to={link.href} className={className} onClick={onClick}>
        {link.label}
      </Link>
    );
  }
  return (
    <a href={link.href} className={className} onClick={onClick}>
      {link.label}
    </a>
  );
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#08090c]/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-[68px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3">
          <img src={logo} alt="Collins Technologiez" className="h-11 w-auto object-contain" />
          <span className="leading-tight">
            <span className="block font-cond font-700 text-white text-[15px] tracking-wide">
              COLLINS <span className="text-sky-400">TECHNOLOGIEZ</span>
            </span>
            <span className="block text-[10px] tracking-[0.25em] text-gray-500 uppercase">Repair Specialists</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <NavItem key={l.label} link={l} className="nav-link text-sm font-medium" />
          ))}
        </div>

        <a
          href={`tel:+1${CONTACT.phone}`}
          className="hidden lg:flex items-center gap-2 btn-blue px-4 py-2 rounded-md text-sm font-semibold"
        >
          <Phone className="w-4 h-4" /> Call Now
        </a>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-[#08090c] border-b border-white/10 px-5 py-4 space-y-3">
          {NAV_LINKS.map((l) => (
            <NavItem
              key={l.label}
              link={l}
              onClick={() => setOpen(false)}
              className="block nav-link text-base py-1"
            />
          ))}
          <a
            href={`tel:+1${CONTACT.phone}`}
            className="flex items-center justify-center gap-2 btn-blue px-4 py-2.5 rounded-md text-sm font-semibold mt-2"
          >
            <Phone className="w-4 h-4" /> Call Now
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
